import { Mark } from '@tiptap/core';
import i18n from '@/shared/i18n';

/**
 * Custom TipTap mark for text that was added in a diff.
 * Renders as an <ins> element with green styling.
 */
export const DiffAdded = Mark.create({
  name: 'diffAdded',

  parseHTML() {
    return [{ tag: 'ins' }];
  },

  renderHTML() {
    return [
      'ins',
      {
        class: 'diff-added',
        'aria-label': i18n.t('common.diff.added'),
      },
      0,
    ];
  },
});

/**
 * Custom TipTap mark for text that was removed in a diff.
 * Renders as a <del> element with red styling and strikethrough.
 */
export const DiffDeleted = Mark.create({
  name: 'diffDeleted',

  parseHTML() {
    return [{ tag: 'del' }];
  },

  renderHTML() {
    return [
      'del',
      {
        class: 'diff-deleted',
        'aria-label': i18n.t('common.diff.deleted'),
      },
      0,
    ];
  },
});
